module.exports = __webpack_public_path__ + "static/media/Apr29-S19.f0b82ccc.png";